var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"indexHead"},[_c('Header')],1),_c('div',[_c('Banner')],1),_c('div',{staticClass:"indexMain"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }